import { render, staticRenderFns } from "./appointmentConfirmation.vue?vue&type=template&id=5165c622&"
import script from "./appointmentConfirmation.vue?vue&type=script&lang=js&"
export * from "./appointmentConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports